<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-12">
                <h3>Upload Documents</h3>
            </div>
            <div class="col-lg-8">
                <div class="row form-options">
                    <div class="col-lg-6">
                        <cnic-front></cnic-front>
                    </div>
                    <div class="col-lg-6">
                        <cnic-back></cnic-back>
                    </div>
                    <div class="col-lg-6">
                        <proof-of-address></proof-of-address>
                    </div>
                    <div class="col-lg-6">
                        <proof-of-employer-address></proof-of-employer-address>
                    </div>

                    <div class="col-lg-6">
                        <proof-of-relative></proof-of-relative>
                    </div>
                    <div class="col-lg-6">
                        <zakat-declaration></zakat-declaration>
                    </div>
                    <div class="col-lg-6"></div>
                    <div class="col-lg-6">
                        <base-button
                            btn-type="submit"
                            btn-variant="primary"
                            btn-label="CONTINUE"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                        ></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
        </div>
    </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
//import _ from 'lodash'

//import IdentityType from '@/components/registration/IdentityType.vue'
import CnicFront from '@/components/registration/CnicFront.vue'
import CnicBack from '@/components/registration/CnicBack.vue'
import ProofOfRelative from '@/components/registration/ProofOfRelative.vue'
import ProofOfAddress from '@/components/registration/ProofOfAddress.vue'
import ProofOfEmployerAddress from '@/components/registration/ProofOfEmployerAddress'
import ZakatDeclaration from '@/components/registration/ZakatDeclaration'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        //      IdentityType,
        //      IdentityDocument,
        // ProofOfIban,
        ProofOfRelative,
        CnicFront,
        CnicBack,
        ProofOfAddress,
        ProofOfEmployerAddress,
        ZakatDeclaration,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        // }, // End of user() method
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        //  this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                // this.$store.commit('setLoading', true)
                let registrationUrl = '/customers/face-to-face'
                if (this.$route.meta.publicRegistration === true) {
                    registrationUrl = '/customers/non-face-to-face'
                }
                const formData = this.$store.state.registration.form
                console.log('formData', formData)
                formData.dataSegmentId = this.dataSegmentId

                const { data } = await request({
                    url: registrationUrl,
                    method: 'post',
                    data: formData,
                })
                this.$store.commit('updateField', {
                    key: 'idenfoId',
                    value: data.data.idenfoId,
                })

                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-finish',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push('/details-form/finish')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > mounted
} // End of export default
</script>
